// import React, {
//   useEffect,
//   useState,
// } from "react";

// import {
//   useNavigate,
// } from "react-router-dom";

// import getBookingSubdomain from "../../../../utils/getBookingSubdomain";

// import {
//   getBookingProperty,
// } from "../../../../api/bookingEngine";

// import CabBookingModal from "./Components/CabBookingModal";


// const CabBooking = () => {

//   const navigate =
//     useNavigate();


//   /* =====================================
//      PROPERTY
//   ===================================== */

//   const [
//     property,
//     setProperty,
//   ] = useState(null);


//   const [
//     loading,
//     setLoading,
//   ] = useState(true);


//   const [
//     error,
//     setError,
//   ] = useState("");


//   /* =====================================
//      LOAD PROPERTY
//   ===================================== */

//   useEffect(() => {

//     const loadProperty =
//       async () => {

//         try {

//           setLoading(true);

//           setError("");


//           /* ---------------------------------
//              GET SUBDOMAIN
//           --------------------------------- */

//           const subdomain =
//             getBookingSubdomain();


//           console.log(
//             "🚕 CAB BOOKING SUBDOMAIN:",
//             subdomain
//           );


//           if (!subdomain) {

//             throw new Error(
//               "Property not identified."
//             );

//           }


//           /* ---------------------------------
//              GET PROPERTY
//           --------------------------------- */

//           const response =
//             await getBookingProperty(
//               subdomain
//             );


//           console.log(
//             "🏨 CAB PROPERTY RESPONSE:",
//             response
//           );


//           if (
//             !response?.success
//           ) {

//             throw new Error(
//               response?.message ||
//               "Unable to load property."
//             );

//           }


//           setProperty(
//             response.property
//           );


//         } catch (error) {

//           console.error(
//             "❌ CAB PROPERTY ERROR:",
//             error
//           );


//           setError(
//             error?.message ||
//             "Unable to load property."
//           );


//         } finally {

//           setLoading(false);

//         }

//       };


//     loadProperty();


//   }, []);


//   /* =====================================
//      GET TENANT ID DYNAMICALLY
//   ===================================== */

//   const tenantId =
//     property?.tenantId ||
//     property?.tenant?._id ||
//     property?.tenant?.tenantId ||
//     "";


//   /* =====================================
//      LOADING
//   ===================================== */

//   if (loading) {

//     return (

//       <div
//         style={{
//           minHeight:
//             "100vh",

//           display:
//             "flex",

//           alignItems:
//             "center",

//           justifyContent:
//             "center",
//         }}
//       >

//         Loading Cab Booking...

//       </div>

//     );

//   }


//   /* =====================================
//      ERROR
//   ===================================== */

//   if (error) {

//     return (

//       <div
//         style={{
//           minHeight:
//             "100vh",

//           display:
//             "flex",

//           flexDirection:
//             "column",

//           alignItems:
//             "center",

//           justifyContent:
//             "center",
//         }}
//       >

//         <h3>
//           Unable to load Cab Booking
//         </h3>

//         <p>
//           {error}
//         </p>

//         <button
//           onClick={() =>
//             navigate(
//               "/booking-engine"
//             )
//           }
//         >
//           Back to Booking
//         </button>

//       </div>

//     );

//   }


//   /* =====================================
//      VALIDATE TENANT
//   ===================================== */

//   if (!tenantId) {

//     return (

//       <div
//         style={{
//           minHeight:
//             "100vh",

//           display:
//             "flex",

//           alignItems:
//             "center",

//           justifyContent:
//             "center",
//         }}
//       >

//         Tenant information not found.

//       </div>

//     );

//   }


//   /* =====================================
//      RENDER
//   ===================================== */

//   return (

//     <CabBookingModal

//       isOpen={true}

//       toggle={() =>
//         navigate(
//           "/booking-engine"
//         )
//       }

//       tenantId={tenantId}

//     />

//   );

// };


// export default CabBooking;

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import getBookingSubdomain from "../../../../utils/getBookingSubdomain";

import {
  getBookingProperty,
} from "../../../../api/bookingEngine";

import CabBookingSearchPage from "./Components/CabBookingSearchPage";


const CabBooking = () => {

  const navigate =
    useNavigate();


  /* =====================================
     PROPERTY
  ===================================== */

  const [
    property,
    setProperty,
  ] = useState(null);


  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    error,
    setError,
  ] = useState("");


  /* =====================================
     LOAD PROPERTY
  ===================================== */

  useEffect(() => {

    const loadProperty =
      async () => {

        try {

          setLoading(true);

          setError("");


          /* ---------------------------------
             GET SUBDOMAIN
          --------------------------------- */

          const subdomain =
            getBookingSubdomain();


          console.log(
            "🚕 CAB BOOKING SUBDOMAIN:",
            subdomain
          );


          if (!subdomain) {

            throw new Error(
              "Property not identified."
            );

          }


          /* ---------------------------------
             GET PROPERTY
          --------------------------------- */

          const response =
            await getBookingProperty(
              subdomain
            );


          console.log(
            "🏨 CAB PROPERTY RESPONSE:",
            response
          );


          if (
            !response?.success
          ) {

            throw new Error(
              response?.message ||
              "Unable to load property."
            );

          }


          setProperty(
            response.property
          );


        } catch (error) {

          console.error(
            "❌ CAB PROPERTY ERROR:",
            error
          );


          setError(
            error?.message ||
            "Unable to load property."
          );


        } finally {

          setLoading(false);

        }

      };


    loadProperty();


  }, []);


  /* =====================================
     GET TENANT ID
  ===================================== */

  const tenantId =
    property?.tenantId ||
    property?.tenant?._id ||
    property?.tenant?.tenantId ||
    "";


  /* =====================================
     LOADING
  ===================================== */

  if (loading) {

    return (

      <div
        style={{
          minHeight:
            "100vh",

          display:
            "flex",

          alignItems:
            "center",

          justifyContent:
            "center",
        }}
      >

        Loading Cab Booking...

      </div>

    );

  }


  /* =====================================
     ERROR
  ===================================== */

  if (error) {

    return (

      <div
        style={{
          minHeight:
            "100vh",

          display:
            "flex",

          flexDirection:
            "column",

          alignItems:
            "center",

          justifyContent:
            "center",
        }}
      >

        <h3>
          Unable to load Cab Booking
        </h3>

        <p>
          {error}
        </p>

        <button
          onClick={() =>
            navigate(
              "/booking-engine"
            )
          }
        >
          Back to Booking
        </button>

      </div>

    );

  }


  /* =====================================
     VALIDATE TENANT
  ===================================== */

  if (!tenantId) {

    return (

      <div
        style={{
          minHeight:
            "100vh",

          display:
            "flex",

          alignItems:
            "center",

          justifyContent:
            "center",
        }}
      >

        Tenant information not found.

      </div>

    );

  }


  /* =====================================
     RENDER FULL PAGE
  ===================================== */

  return (

    <CabBookingSearchPage

      tenantId={tenantId}

      property={property}

      onBack={() =>
        navigate(
          "/booking-engine"
        )
      }

    />

  );

};


export default CabBooking;